import Module from '../../modules/Module';

export default class Accountancy extends Module {
  static Info = {
      "nameResource": "accountancy",
      "icon": "fas fa-money-check-alt", // admin-accountancy-color
      "path": "",
      "show": true
  };
}